import React from "react";
import { Modal, Button, Typography, Divider } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import useAiAssessmentStart from "../../hooks/useAiAssessmentStart";
import "./modals.scss";

const CursorFocusChangeModal: React.FC = () => {
  const {
    showCursorFocusChangeModal,
    setShowCursorFocusChangeModal,
    fullscreenElementRef,
    isFullscreen,
    cursorFocuChangeModalRef,
    clearExitFullScreenState,
  } = useAIAssessmentContext();

  const { toggleToFullscreenMode } = useAiAssessmentStart();

  const handleClose = () => {
    setShowCursorFocusChangeModal(false);
    if (!isFullscreen) {
      toggleToFullscreenMode();
    }
    clearExitFullScreenState();
  };

  return (
    <div ref={cursorFocuChangeModalRef}>
      <Modal
        closeIcon={false}
        destroyOnClose={true}
        centered
        keyboard={false}
        open={showCursorFocusChangeModal}
        onCancel={handleClose}
        maskClosable={false}
        footer={null}
        getContainer={
          isFullscreen ? () => fullscreenElementRef.current! : undefined
        }
      >
        <div className="modal-content">
          <div className="modal-content-header">
            <Typography.Title level={5} style={{ margin: 0 }}>
              Cursor Focus Change Detected !!
            </Typography.Title>
          </div>
          <Divider style={{ margin: 0 }} />
          <div className="violation-modal-content-icon">
            <WarningOutlined />
          </div>

          <Typography.Text>
            Cursor focus has been changed during the AI Assessment Rounds.
            Please ensure your cursor is focused on the screen.
          </Typography.Text>
        </div>
        <div className="ai-assessment-modal-footer">
          <Button type="default" onClick={handleClose}>
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default CursorFocusChangeModal;
